import { Box, Stack, useTheme } from "@mui/material";
import { LucideIcon } from 'lucide-react';
import UIIcon from '../ui-icon';

type GameCategoryItemProps = {
    category: any;
    icon: LucideIcon;
    color: string;
    onToggle: (id: number) => void;
    selected: boolean
};

export default function GameCategoryItem({ category, icon, color, onToggle, selected}: GameCategoryItemProps) {
    const theme = useTheme();

    return (
        <Box padding={2} sx={{ cursor: "pointer" }} borderRadius={1} bgcolor={theme.palette.background.default} display={"flex"} onClick={() => onToggle(category.id)}>
            <Stack direction="row" gap={1}>
                <Box display={"flex"}>
                    <UIIcon icon={icon} color={ selected ? color : theme.palette.secondary.main} />
                </Box>
                {category.name}
            </Stack>
        </Box>
    );
}
